export const API_BONDS = '/dragon-x-bonds';

export const API_BOND_INFO = `${API_BONDS}/info`;
export const API_BOND_SIGN_MINT = `${API_BONDS}/sign-mint`;
export const API_BOND_SIGN_REDEEM = `${API_BONDS}/sign-redeem`;
export const API_BOND_TOTAL_REWARDS_DISTRIBUTED = `${API_BONDS}/total-rewards-distributed`;
export const API_BOND_ACTION_HISTORY = `${API_BONDS}/action-history`;
export const API_BOND_PERFORMANCE_METRICS = `${API_BONDS}/performance-metrics`;
